import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'videoOrigin',
  standalone: true,
})
export class VideoOriginPipe implements PipeTransform {
  transform(video_origin: string, key: 'uuid' | 'origin'): string {
    const params = new URLSearchParams(video_origin.split('?')[1]);
    const uuid = params.get('uuid');
    if (key === 'uuid') {
      return uuid ?? '';
    }
    return `${uuid}.jpg`;
  }
}
